import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import React from "react";
import { Link } from "react-router-dom";
import { useClickOutsideEl, useKeyPress } from "../../../../utils/hooks";
import { MenuItem } from "../types";

interface Props {
    items: MenuItem[];
    onNavigate: () => void;
}

export const MenuItems: React.FC<Props> = ({ items, onNavigate }) => {
    const outerRef = React.useRef<HTMLUListElement>(null);
    const [openIndex, setOpenIndex] = React.useState(-1);

    const closeOpenMenu = () => {
        setOpenIndex(-1);
    };

    useKeyPress("Escape", closeOpenMenu);

    useClickOutsideEl(outerRef, closeOpenMenu);

    const handleNavigate = () => {
        closeOpenMenu();
        onNavigate();
    };

    return (
        <ul ref={outerRef}>
            {items.map((item, index) => {
                let content;
                switch (item.type) {
                    case "link":
                        content = (
                            <Link onClick={handleNavigate} to={item.to}>
                                {item.title}
                            </Link>
                        );
                        break;
                    case "dropdown":
                        {
                            const isOpen = openIndex === index;
                            content = (
                                <>
                                    <button
                                        onClick={() => {
                                            if (isOpen) {
                                                setOpenIndex(-1);
                                            } else {
                                                setOpenIndex(index);
                                            }
                                        }}
                                    >
                                        {item.title}
                                        {isOpen ? (
                                            <ExpandLessRoundedIcon />
                                        ) : (
                                            <ExpandMoreRoundedIcon />
                                        )}
                                    </button>
                                    {isOpen && (
                                        <MenuItems
                                            onNavigate={handleNavigate}
                                            items={item.children}
                                        />
                                    )}
                                </>
                            );
                        }
                        break;
                }
                return <li key={index}>{content}</li>;
            })}
        </ul>
    );
};
